module.exports = {
  context: {
    masthead: '@masthead',
    hero: {
      type: 'text-only',
      heading: {
        text: 'Our Team',
        tag: 'h1',
        class: 'heading-1'
      }
    },
    team: '@cm-team',
    footer: '@footer'
  }
}
